import Treding from "./Treding";

export default Treding;
